import { useState } from 'react';
import { useAppSelector } from '@acorn-portal/shared/src/hooks/reduxHook';

type FormState = 'hidden' | 'editing-proposer' | 'editing-additional' | 'creating-additional';

export const usePageState = (driverLimit: number) => {
	const [activeDriverIndex, setActiveDriverIndex] = useState<number | null>(null);
	const [formStatus, setFormStatus] = useState<FormState>('hidden');
	const drivers = useAppSelector((store) => store.subscriptionAmendDrivers.data);
	const totalDrivers = drivers.length ?? 0;

	// Form state modifiers
	const showExistingDriverForm = (index: number) => {
		setActiveDriverIndex(index);
		const status = drivers[index].isProposer ? 'editing-proposer' : 'editing-additional';
		setFormStatus(status);
	};

	const showNewDriverForm = () => {
		if (totalDrivers < driverLimit) {
			setActiveDriverIndex(totalDrivers);
			setFormStatus('creating-additional');
		}
	};

	const resetForm = () => {
		setActiveDriverIndex(null);
		setFormStatus('hidden');
	};

	return {
		formStatus,
		activeDriverIndex,
		setActiveDriverIndex,
		showExistingDriverForm,
		showNewDriverForm,
		resetForm,
	};
};
